import Joyride, { ACTIONS, EVENTS, STATUS } from 'react-joyride';

const OnBoardingTooling = {
  isTourChangingStep: (data) => {
    const { type } = data;
    return [EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type);
  },
  setTourStep: (data, containerObject) => {    
    const { action, index, status, type } = data;
    containerObject.setState({ tourStepIndex: index + (action === ACTIONS.PREV ? -1 : 1) });
  },
  isEnteringStepBackwards: (data) => {
    const { action, type } = data;
    return action === ACTIONS.PREV && type === EVENTS.STEP_BEFORE;
  },
  isEnteringStepForwards: (data) => {
    const { action, type } = data;
    return action === ACTIONS.NEXT && type === EVENTS.STEP_BEFORE;  //Note: EVENTS.STEP_BEFORE is the correct behaviour (in oppose of STEP_AFTER)
  },
  endTour: (containerObject) => {
    containerObject.setState({
      setOnBoardingActive: false,
      tourStepIndex: 0,
    });
  },
  handleTourSteps: (data, containerObject) => {
    const { status, type, step } = data;
    if(step.onEnteringStepForwardsClick && OnBoardingTooling.isEnteringStepForwards(data)){
      document.getElementById(step.onEnteringStepForwardsClick).click();
    }
    if(step.onEnteringStepBackwardsClick && OnBoardingTooling.isEnteringStepBackwards(data)){
      document.getElementById(step.onEnteringStepBackwardsClick).click();
    }
    if(OnBoardingTooling.isTourChangingStep(data)){
      OnBoardingTooling.setTourStep(data, containerObject);
    }
    else if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)){
      OnBoardingTooling.endTour(containerObject);
    }
  },
};

export default OnBoardingTooling;


// WEBPACK FOOTER //
// ./source/tooling/onBoardingTooling.js